import { render, staticRenderFns } from "./UnitsMap.vue?vue&type=template&id=1f306dd9"
import script from "./UnitsMap.vue?vue&type=script&lang=js"
export * from "./UnitsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports